// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"ec620ee0","190":"8c9caae1","726":"17720215"}[chunkId] + ".chunk.js";
};